import { baseApi } from "../baseApi";

export interface Feedback {
  id: string;
  studentName: string;
  studentEmail: string;
  rating: number;
  feedbackText: string;
  createdAt: string;
}

export const feedbackApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeedbacks: builder.query<Feedback[], void>({
      query: () => "/api/feedback",
      transformResponse: (response: any) => {
        if (Array.isArray(response)) return response;
        if (Array.isArray(response?.data)) return response.data;
        if (Array.isArray(response?.feedbacks)) return response.feedbacks;
        return [];
      },
      providesTags: ["Feedback" as any],
    }),
  }),
});

export const { useGetFeedbacksQuery } = feedbackApi;
